import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-lucky-draw-modal',
  templateUrl: './lucky-draw-modal.component.html',
  styleUrls: ['./lucky-draw-modal.component.scss']
})
export class LuckyDrawModalComponent {

  @Input() set player(val:any) {
    this._player = val;
    this.getExistingVoucher();
  }
  private _player:any = {}
  @Output() saveEvent = new EventEmitter();
  public sections:any = [];
  public draws:any = [];
  public vouchers:any = [];
  private default_value = 0;
  constructor(private http: HttpService) { 
    this.initSection();
  }

  async initSection() {
    this.sections = await this.http.post("/admin/app/voucher/section/get");
    let f = this.sections.find((v:any) => {
      return v.value === 0;
    })

    if(!f) {
      this.default_value = this.sections[0].value;
    }

    this.draws.push({winning: this.default_value})

  }

  async getExistingVoucher() {
    let v:any = await this.http.post("/admin/app/voucher/mass/get", {player: this._player});
    this.vouchers = v.vouchers
  }

  add() {
    this.draws.push({winning: this.default_value})
  }

  remove(index:number) {
    this.draws.splice(index, 1)
  } 

  async save() {
    await this.http.post("/admin/app/voucher/mass/save", {draws: this.draws, player: this._player});
    this.saveEvent.emit(true);
  }
}
